import { KAvatarAutocomplete } from "kinnect-general";

export default {
	name: "UserField",

	extends: KAvatarAutocomplete,

	props: {
		itemText: {
			default: "name",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		noDataText: {
			default: "No users to display",
			type: String
		},
		prependIcon: {
			default: "person",
			type: String
		}
	}
};
